import { Empty, Typography } from 'antd';

export const EmptyData = () => {

  return (
    <Empty
    image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
    imageStyle={{ height: 60 }}
    description={
      <Typography.Text>
        Данных нет
      </Typography.Text>
    }
  >
  </Empty>
  );
};
